import { browser } from '$app/environment';

class EmailCapture {
	#successfullyEntered = $state(false);

	constructor() {
		if (!browser) return;

		this.#successfullyEntered = sessionStorage.getItem('newsletter-modal') === 'success';
	}

	get successfullyEntered() {
		return this.#successfullyEntered;
	}

	enter() {
		sessionStorage.setItem('newsletter-modal', 'success');
		this.#successfullyEntered = true;
	}
}

export const emailCapture = new EmailCapture();
